import axios from './APIAxios';
import storage from '../storage';
import Api from "./APIAxios";
import { IRelatorioAnaliticoRondaBody, IRelatorioAnaliticoRondaResponse, ISituacoesRondaRondaResponse } from '../@interfaces/rondas';
import { mockRondas } from '../pages/relatorios/relatorioanaliticoronda/mock';




const APIRelatorios = {
  getRelatorioAnaliticoRonda: async function (body: IRelatorioAnaliticoRondaBody): Promise<IRelatorioAnaliticoRondaResponse> {
    console.log(body);
    
    const url = storage.getClientUrl();
    try {
      // TODO: trocar pelo endpoint real quando existir
      // return {
      //   status: 0,
      //   rondas: mockRondas
      // };

      const response = await Api.post<IRelatorioAnaliticoRondaResponse>(`${url}/buscarRelatorioAnaliticoRonda`, body);
      if (response.data.status !== 0) {
        return { error: true, message: response.data.mensagem }
      } else {
        
        return response.data;
      }
    } catch (e) {
      console.log(e);
      return { error: true, message: 'Algo deu errado' };
    }
  },


  getSituacoesRonda: async function (): Promise<ISituacoesRondaRondaResponse> {
    
    const url = storage.getClientUrl();
    try {
      // TODO: trocar pelo endpoint real quando existir
      // return {
      //   status: 0,
      //   rondas: mockRondas
      // };

      const response = await Api.get<ISituacoesRondaRondaResponse>(`${url}/situacoesRonda`);
      if (response.data.status !== 0) {
        return { error: true, message: response.data.mensagem }
      } else {
        return response.data;
      }
    } catch (e) {
      console.log(e);
      return { error: true, message: 'Algo deu errado' };
    }
  },
}

export default APIRelatorios;